export default function PHP_ftruncate() {
  return (
    <div>
      <h1>PHP_ftruncate</h1>
    </div>
  );
}
